import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const SubscriptionCanceled = () => {
  const navigate = useNavigate();

  const handleBackToPlans = () => {
    navigate('/subscription');
  };

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          {/* Canceled Icon */}
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-gray-100 mb-6">
            <XCircle className="h-10 w-10 text-gray-400" />
          </div>

          {/* Message */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Subscription Canceled
          </h1>
          
          <p className="text-lg text-gray-600 mb-6">
            No worries! Your subscription setup was canceled. You can try again anytime.
          </p>

          {/* Information */}
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
            <h3 className="font-semibold text-gray-900 mb-2">
              💡 What Happened?
            </h3>
            <p className="text-gray-700 text-sm">
              You can still access your account and explore our features. 
              When you're ready, you can subscribe to any plan and start your free trial.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <button
              onClick={handleBackToPlans}
              className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200"
            >
              Try Again
            </button>
            
            <button
              onClick={handleGoToDashboard}
              className="w-full bg-gray-100 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-200 transition-colors duration-200"
            >
              Go to Dashboard
            </button>
          </div>

          {/* Help Section */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <h3 className="font-semibold text-gray-900 mb-3">Need Help?</h3>
            <p className="text-sm text-gray-600 mb-4">
              If you encountered any issues or have questions about our plans, 
              our support team is here to help.
            </p>
            
            <div className="space-y-2 text-sm">
              <p className="text-gray-600">
                📧 Email:{' '}
                <a href="mailto:support@receevit.com" className="text-blue-600 hover:underline">
                  support@receevit.com
                </a>
              </p>
              <p className="text-gray-600">
                💬 Live Chat: Available in your dashboard
              </p>
            </div>
          </div>

          {/* FAQ Link */}
          <div className="mt-6">
            <button
              onClick={() => navigate('/subscription')}
              className="text-blue-600 hover:text-blue-700 text-sm font-medium"
            >
              View Subscription Plans →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCanceled;
